import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { editWorkbook } from '../../../actions/spaces/EditWorkbookAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditWorkbookAction: IEntityAction<IContentInfo<'workbook'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editWorkbook_action,
  isVisible: () => true,
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => {
    return editWorkbook(targetItems[0]);
  }
};
